export enum userManagementSections {
  users = 'users',
  notifications = 'notifications',
  news = 'news',
}
